<section id="programme-example" class="section section--programme-example" aria-labelledby="programme-example-title">
  <div class="wrap">
    <div class="programme-example__heading">
      <div class="readable">
        <p class="eyebrow">Example</p>
        <h2 class="title" id="programme-example-title">One Programme Can Use One or More Assessments</h2>
        <p>
          A management course may need one wheel for delegation and another for difficult conversations. Each wheel can use its own
          categories and scoring guidance while retaining a consistent experience across the programme.
        </p>
      </div>
    </div>
    <div class="programme-wheels">
      <article id="delegation-panel" class="programme-wheel-card" aria-labelledby="delegation-tab">
        <header>
          <span>Assessment 01</span>
          <h3>Delegation Skills</h3>
        </header>
        <div class="programme-wheel-card__content">
          <div class="hero-img"><img src="assets/delegation8.jpg" alt="Wheel of Life for Delegations Skill set" /></div>
          <ol class="example-categories">
            @for (category of delegationCategories(); track category; let index = $index) {
            <li>
              <span>{{ index + 1 }}</span
              >{{ category }}
            </li>
            }
          </ol>
        </div>
      </article>
      <article id="conversations-panel" class="programme-wheel-card" aria-labelledby="conversations-tab">
        <header>
          <span>Assessment 02</span>
          <h3>Difficult Conversations</h3>
        </header>
        <div class="programme-wheel-card__content">
          <div class="hero-img"><img src="assets/conversation.jpg" alt="Wheel of Life for Conversations Skill set" /></div>
          <ol class="example-categories">
            @for (category of conversationCategories(); track category; let index = $index) {
            <li>
              <span>{{ index + 1 }}</span
              >{{ category }}
            </li>
            }
          </ol>
        </div>
      </article>
    </div>
    <p class="programme-example__caption">
      Participants can complete an assessment before a module, repeat it after practice and download each result as an image for comparison
      and discussion.
    </p>
  </div>
</section>
